import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import HistoryIcon from '@mui/icons-material/History';
import { FiltersBar } from '../components/FiltersBar';
import { ActionsTable } from '../components/ActionsTable';
import { useUserActions } from '../hooks/use-user-actions';
import { USE_NEW_SHELL } from 'core/flags';
import { PageShell } from 'components/AppShell';

export default function UserActionsPage() {
  const {
    filters,
    setFilters,
    resetFilters,
    items,
    count,
    loading,
    error,
    page,
    setPage,
    setLimit,
  } = useUserActions();

  const body = (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FiltersBar filters={filters} onChange={setFilters} onReset={resetFilters} />
      <ActionsTable
        items={items}
        count={count}
        loading={loading}
        error={error}
        page={page}
        limit={filters.limit}
        onPageChange={setPage}
        onLimitChange={setLimit}
        onFilterBySubject={(subjectType, subjectId) =>
          setFilters((prev) => ({ ...prev, subject_type: subjectType, subject_id: subjectId }))
        }
        onChangeFilters={setFilters}
      />
    </Box>
  );

  if (USE_NEW_SHELL) {
    return (
      <PageShell
        title="Журнал действий"
        subtitle="Аудит state-changing операций пользователей платформы"
        bodyScrolls={false}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', minHeight: 0 }}
        >
          <Box sx={{ flexShrink: 0 }}>
            <FiltersBar filters={filters} onChange={setFilters} onReset={resetFilters} />
          </Box>
          <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
            <ActionsTable
              items={items}
              count={count}
              loading={loading}
              error={error}
              page={page}
              limit={filters.limit}
              onPageChange={setPage}
              onLimitChange={setLimit}
              onFilterBySubject={(subjectType, subjectId) =>
                setFilters((prev) => ({
                  ...prev,
                  subject_type: subjectType,
                  subject_id: subjectId,
                }))
              }
              onChangeFilters={setFilters}
            />
          </Box>
        </Box>
      </PageShell>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{
          p: 1.5,
          borderRadius: 2,
          background: (t) => t.palette.background.paper,
          border: (t) => `1px solid ${t.palette.divider}`,
          borderLeft: (t) => `3px solid ${t.palette.primary.main}`,
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: (t) => t.palette.primary.main,
            color: 'white',
            boxShadow: (t) => `0 2px 8px ${alpha(t.palette.primary.main, 0.35)}`,
            flexShrink: 0,
          }}
        >
          <HistoryIcon fontSize="small" />
        </Box>
        <Box>
          <Typography sx={{ fontSize: '1.05rem', fontWeight: 700, lineHeight: 1.2 }}>
            Журнал действий
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Аудит state-changing операций пользователей платформы
          </Typography>
        </Box>
      </Stack>
      {body}
    </Box>
  );
}
